import React from 'react';

import { SelectionButtonProps } from './SelectionButton.props';
import { StyledDiv } from './SelectionButton.styles';
import { SelectMenu } from '../../atoms/SelectMenu';

export const SelectionButton: React.FC<SelectionButtonProps> = ({
  label,
  value,
  error,
  onClick,
  disabled = false,
  readOnly = true
}) => {
  return (
    <StyledDiv onClick={onClick}>
      <SelectMenu 
        id="selection-button"
        label={label}
        items={[{ value: value, label: value }]}
        selectedValue={value}
        validate={error}
        disabled={disabled}
        readOnly={readOnly}
      />
    </StyledDiv>
  );
};